import { useState } from 'react';

import { useCurrentInstance } from '@/api/organization';
import ChevronDown from '@/assets/svg/chevron-down.svg?react';
import { GlobalLoader } from '@/components/GlobalLoader';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/Popover';
import { SidebarMenuButton } from '@/components/Sidebar';
import { Text } from '@/components/typography';
import { ROUTES } from '@/router';

import InstanceSwitcherContent from './InstanceSwitcherContent';

const InstanceSwitcher = () => {
  const { instance } = useCurrentInstance();
  const [open, setOpen] = useState(false);
  const [isSwitching, setIsSwitching] = useState(false);

  const handleSelectInstance = async (instanceId: string) => {
    setOpen(false);
    setIsSwitching(true);

    // Change url to the new instance. This will trigger a session exchange.
    window.location.href = ROUTES.appByInstanceId(instanceId);
  };

  if (isSwitching) {
    return <GlobalLoader />;
  }

  return (
    <Popover open={open} onOpenChange={setOpen} modal={false}>
      <PopoverTrigger
        render={
          <SidebarMenuButton className="h-auto rounded-lg bg-gray-100 p-3">
            <Text variant="body2" weight="semi-bold" className="min-w-0 flex-1 whitespace-normal">
              {instance?.name}
            </Text>
            <ChevronDown />
          </SidebarMenuButton>
        }
      />
      <PopoverContent side="bottom" align="start" className="w-auto gap-0 p-0 shadow-2xl">
        <InstanceSwitcherContent
          onInstanceChange={handleSelectInstance}
          onClose={() => setOpen(false)}
        />
      </PopoverContent>
    </Popover>
  );
};

export default InstanceSwitcher;
